<style lang="scss">

</style>
<template>
    <div style="margin: 20px 0">
        <Table :columns="dataColumns" :data="taskData" size="small" style="position: relative"></Table>
        <!-- <div>task_no:{{datajson.task_no}}</br>status:{{datajson.status}}</br>msg:{{datajson.msg}}</div>
        <div class="margin-top-10" v-if="keyArr.length>1" >
            <div v-for="(item,index) in keyArr" :key="index">
                <span class="font-bold">文件详情 {{index}}:</span>
                <div v-for="(json,key) in item.key_value" :key="key">{{key}}:{{json}}</div>
            </div>
        </div>
        <div v-else>
            <div class="margin-top-10" v-for="(item,index) in keyArr" :key="index">
                <div v-for="(json,key) in item.key_value" :key="key">{{key}}:{{json}}</div>
            </div>
        </div> -->
        <compModal v-model="modalProps.show" v-bind="modalProps" @on-close="closemodalprops" @on-confirm="modalProps.show=false">
			<component ref="cusref" :is="modalProps.component" v-bind="modalProps.props" v-on="modalProps.on"/>
		</compModal>
    </div>
</template>

<script>
import { HttpFuelDetailFile, HttpAdjustOne } from '@/service/costbilling';
export default {
    props:['activeid', 'details'],
    data(){
        return {
            datajson:null,
            keyArr: [],
            taskData: [],
            country: this.details.country || '',
            carrierCode: this.details.carrierCode || '',
            modalProps: {
				show: false,
			},
        }
    },
    created(){
        HttpFuelDetailFile({
            id:this.activeid
        }).then(res=>{
            this.datajson = res.data;
            this.keyArr = res.data.data;
            // res.data.data.map(item=>{
            //     this.taskData.push(item.key_value)
            // })
            this.taskData.push(res.data.data[0].key_value)
        })
        // this.datajson = JSON.parse(this.metalist)
    },
    computed: {
        dataColumns(){
            let columns;
            const CAUPS =  [
                {
                    title: '操作',
                    render: (h,{row})=>{
                        return <Button type="primary" onClick={this.adjust.bind(this, row.id)}>审核</Button>
                    },
                    align: 'center',
                    width: '100'
                },
                {
                    title: 'Effective Start Date',
                    key: 'EffectiveStartDate',
                    render:(h,{row})=>{
                        return <div>
                            {row.EffectiveStartDate || '--'}
                        </div>
                    },
                    width: '160',
                },
                {
                    title: 'Standard Service to the U.S',
                    key: 'StandardServicetotheU.S.:',
                    render:(h,{row})=>{
                        return <div>
                            {row['StandardServicetotheU.S.:'] || '--'}
                        </div>
                    },
                    width: '150'
                },
                {
                    title: 'Standard Service within Canada',
                    key: 'StandardServicewithinCanada:',
                    render:(h,{row})=>{
                        return <div>
                            {row['StandardServicewithinCanada:'] || '--'}
                        </div>
                    },
                },
                {
                    title: 'International Express, Expedited & 3 Day Select',
                    key: 'InternationalExpress,Expedited&3DaySelect:',
                    render:(h,{row})=>{
                        return <div>
                            {row['InternationalExpress,Expedited&3DaySelect:'] || '--'}
                        </div>
                    },
                },
                {
                    title: 'Domestic Express and Expedited',
                    key: 'DomesticExpressandExpedited:',
                    render:(h,{row})=>{
                        return <div>
                            {row['DomesticExpressandExpedited:'] || '--'}
                        </div>
                    },
                }
            ];
            const USAUPS =  [
                {
                    title: '操作',
                    render: (h,{row})=>{
                        return <Button type="primary" onClick={this.adjust.bind(this, row.id)}>审核</Button>
                    },
                    align: 'center',
                    width: '100'
                },
                {
                    title: 'Effective Start Date',
                    key: 'EffectiveStartDate',
                    render:(h,{row})=>{
                        return <div>
                            {row.EffectiveStartDate || '--'}
                        </div>
                    },
                    width: '160',
                },
                {
                    title: 'Domestic Ground Surcharge',
                    key: 'DomesticGroundSurcharge',
                    render:(h,{row})=>{
                        return <div>
                            {row['DomesticGroundSurcharge'] || '--'}
                        </div>
                    },
                    width: '140'
                },
                {
                    title: 'Domestic Air Surcharge',
                    key: 'DomesticAirSurcharge',
                    render:(h,{row})=>{
                        return <div>
                            {row['DomesticAirSurcharge'] || '--'}
                        </div>
                    },
                },
                {
                    title: 'International Air Export Surcharge',
                    key: 'InternationalAirExportSurcharge',
                    render:(h,{row})=>{
                        return <div>
                            {row['InternationalAirExportSurcharge'] || '--'}
                        </div>
                    },
                },
                {
                    title: 'International Air Import Surcharge',
                    key: 'InternationalAirImportSurcharge',
                    render:(h,{row})=>{
                        return <div>
                            {row['InternationalAirImportSurcharge'] || '--'}
                        </div>
                    },
                    width: '110'
                },
                {
                    title: 'International Ground Export Import Surcharge',
                    key: 'InternationalGroundExportImportSurcharge',
                    render:(h,{row})=>{
                        return <div>
                            {row['InternationalGroundExportImportSurcharge'] || '--'}
                        </div>
                    },
                    width: '110'
                }
            ];
            const USAFEDEX =  [
                {
                    title: '操作',
                    render: (h,{row})=>{
                        return <Button type="primary" onClick={this.adjust.bind(this, row.id)}>审核</Button>
                    },
                    align: 'center',
                    width: '100'
                },
                {
                    title: 'Effective Start Date',
                    key: 'EffectiveDate',
                    render:(h,{row})=>{
                        return <div>
                            {row.EffectiveDate || '--'}
                        </div>
                    },
                    width: '120',
                },
                {
                    title: 'Domestic and U.S. to Puerto Rico–Package Services',
                    key: 'DomesticandU.S.toPuertoRico–PackageServices',
                    render:(h,{row})=>{
                        return <div>
                            {row['DomesticandU.S.toPuertoRico–PackageServices'] || '--'}
                        </div>
                    },
                    width: '140'
                },
                {
                    title: 'Domestic and U.S. to Puerto Rico–Freight Services',
                    key: 'DomesticandU.S.toPuertoRico–FreightServices',
                    render:(h,{row})=>{
                        return <div>
                            {row['DomesticandU.S.toPuertoRico–FreightServices'] || '--'}
                        </div>
                    },
                    width: '140'
                },
                {
                    title: 'Export',
                    key: 'Export',
                    render:(h,{row})=>{
                        return <div>
                            {row['Export'] || '--'}
                        </div>
                    },
                    width: '100'
                },
                {
                    title: 'Import',
                    key: 'Import',
                    render:(h,{row})=>{
                        return <div>
                            {row['Import'] || '--'}
                        </div>
                    },
                    width: '100'
                },
                {
                    title: 'Basedon Weekly Fuel Price Reported for 1',
                    key: 'BasedonWeeklyFuelPriceReportedfor1',
                    render:(h,{row})=>{
                        return <div>
                            {row['BasedonWeeklyFuelPriceReportedfor1'] || '--'}
                        </div>
                    },
                    width: '110'
                },
                {
                    title: 'FedExGroundSurcharge',
                    key: 'FedExGroundSurcharge',
                    render:(h,{row})=>{
                        return <div>
                            {row['FedExGroundSurcharge'] || '--'}
                        </div>
                    },
                    width: '110'
                },
                {
                    title: 'Basedon Weekly Fuel Price Reported for 11',
                    key: 'BasedonWeeklyFuelPriceReportedfor1',
                    render:(h,{row})=>{
                        return <div>
                            {row['BasedonWeeklyFuelPriceReportedfor11'] || '--'}
                        </div>
                    },
                    width: '110'
                }
            ]
            columns = this.carrierCode == 'UPS' ? this.country == 'CA' ? CAUPS : USAUPS : USAFEDEX;
            return columns;
        }
    },
    methods:{
        closemodalprops(){
            this.modalProps = {};
            this.$emit('on-openCloseable');
        },
        adjust(obj) {
            this.$emit('on-closeCloseable');
            this.modalProps = {
                show: true,
                alert: "info",
                title: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                width: 400,
                showDesc: true,
                desc: '审核完成后，将最新的燃油费新增至所有下属组织数据中，请谨慎处理！',
                params: { id: this.activeid },
                ajaxRequest: HttpAdjustOne,
                callback: this.cancel
            }
        },
    }
}
</script>
